export interface Props{
	filters: any
}
export interface Recording{
	timestamp: string
	link: string
	id: string
	name: string
	participants: string[]
}

export enum TabStatus {
  Error = 'error',
  Loaded = 'loaded',
  Loading = 'loading',
}
